import { Box, BoxProps, createUseVariantStyle, forwardRef } from '@bonusly/design-system';

import { DropdownVariant } from './types';

interface Props extends BoxProps {
	role?: string;
	variant?: DropdownVariant;
}

const useVariantStyle = createUseVariantStyle({
	variant: {
		floating: {
			borderRadius: 'md',
			_focus: { backgroundColor: 'bg.inset' },
			_hover: { backgroundColor: 'secondary.bgAlpha' },
		},
		static: {
			border: 0,
			borderRadius: 'sm',
			_focus: { backgroundColor: 'bg.inset' },
			_hover: { backgroundColor: 'secondary.bgAlpha' },
		},
	},
});

export const DropdownOption = forwardRef(({ variant = 'static', ...rest }: Props, ref) => {
	return (
		<Box
			bg="transparent"
			cursor="pointer"
			listStyleType="none"
			p={2}
			transitionDuration="normal"
			transitionProperty="common"
			as="li"
			role="option"
			tabIndex={0}
			ref={ref}
			{...useVariantStyle({ variant })}
			{...rest}
		/>
	);
});

export type { Props as DropdownOptionProps };
